import axios, { AxiosError } from 'axios'
import config from '@/config'
import router from '@/router'
import { store } from '@/store/store'

axios.defaults.timeout = 60000

export default {
  methods: {
    async get(url, options = {}, isAuth = true) {
      if (isAuth) options = this.add_token_header(options)
      try {
        let response = await axios.get(this.update_url(url, options), options)
        if (response.status == 200) {
          let data = response.data
          if (data.responsecode) {
            this.defaultResponse(data)
          }
          return data
        } else {
          throw new Error(response)
        }
      } catch (error) {
        let message = ''
        if (error.response) {
          message =
            (error.response.data.error && error.response.data.error.message) ||
            (error.response.data.result && error.response.data.result.message) ||
            error.response.data.error ||
            error.response.data.result ||
            error.response.data.message ||
            ''
        }

        // Skip error
        if (url.includes('invoice_access_bank_account') && message === '(#10) Insufficient permissions to access this data') return error

        this.$swal.fire({ title: error.message, text: message, type: 'error' })
        if (error.response && error.response.status == 401) await this.forceLogout(error.response, message)
        return error
      }
    },
    async post(url, data, options = {}, isAuth = true) {
      if (isAuth) options = this.add_token_header(options)
      try {
        let response = await axios.post(this.update_url(url, options), data, options)
        if (response.status == 200) {
          let data = response.data
          if (data.responsecode) {
            this.defaultResponse(data)
          }
          return data
        } else {
          throw new Error(response)
        }
      } catch (error) {
        let message = ''
        if (error.response) {
          message =
            (error.response.data.result && error.response.data.result.message) ||
            error.response.data.result ||
            error.response.data.message ||
            ''
          return error.response
        }
        this.$swal.fire({ title: error.message, text: message, type: 'error' })
        return error
      }
    },
    async put(url, data, options = {}, isAuth = true) {
      if (isAuth) options = this.add_token_header(options)
      try {
        let response = await axios.put(this.update_url(url, options), data, options)
        if (response.status == 200) {
          let data = response.data
          if (data.responsecode) {
            this.defaultResponse(data)
          }
          return data
        } else {
          throw new Error(response)
        }
      } catch (error) {
        let message = ''
        if (error.response) {
          message =
            (error.response.data.result && error.response.data.result.message) ||
            error.response.data.result ||
            error.response.data.message ||
            ''
        }
        this.$swal.fire({ title: error.message, text: message, type: 'error' })
        return error
      }
    },
    async patch(url, data, options = {}, isAuth = true) {
      if (isAuth) options = this.add_token_header(options)
      try {
        let response = await axios.patch(this.update_url(url, options), data, options)
        if (response.status == 200) {
          let data = response.data
          if (data.responsecode) {
            this.defaultResponse(data)
          }
          return data
        } else {
          throw new Error(response)
        }
      } catch (error) {
        let message = ''
        if (error.response) {
          message =
            (error.response.data.result && error.response.data.result.message) ||
            error.response.data.result ||
            error.response.data.message ||
            ''
        }
        this.$swal.fire({ title: error.message, text: message, type: 'error' })
        return error
      }
    },
    async delete(url, options = {}, isAuth = true) {
      if (isAuth) options = this.add_token_header(options)
      try {
        let response = await axios.delete(this.update_url(url, options), options)
        if (response.status == 200) {
          let data = response.data
          if (data.responsecode) {
            this.defaultResponse(data)
          }
          return data
        } else {
          throw new Error(response)
        }
      } catch (error) {
        let message = ''
        if (error.response) {
          message =
            (error.response.data.result && error.response.data.result.message) ||
            error.response.data.result ||
            error.response.data.message ||
            ''
        }
        this.$swal.fire({ title: error.message, text: message, type: 'error' })
        return error
      }
    },
    update_url(url, options) {
      return (options.custom_url ? options.custom_url : config.serverUrl) + url
    },
    add_token_header(options) {
      if (!options.headers) {
        options.headers = {}
      }

      options['headers']['AUTHORIZATION'] = this.$store.getters.securityToken
      return options
    },
    async defaultResponse(data) {
      if (data.responsecode === 200) {
        return true
      } else if (data.responsecode === 400) {
        let message = data.reason ? data.reason : ''
        await this.forceLogout(data, message)

        throw new Error('Session expire. Please login again.')
      } else {
        if (data.reason) {
          throw new Error(data.reason)
        } else {
        }
      }
    },
    async forceLogout(response, message) {
      var isFacebook = store.state.isFacebook

      await store.dispatch('logout', { code: response.status, message })
      if (router.history.current.name !== 'login' || router.history.current.name !== 'nigol') {
        if (isFacebook) {
          router.push({
            path: '/' + store.getters.currentLang + '/login',
            query: router.query
          })
        } else {
          router.push({
            path: '/' + store.getters.currentLang + '/nigol',
            query: router.query
          })
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/apiMixin.js